import { Column, Row, RowAlignedItems } from '@components/LinearLayout';
import { P, PBold } from '@components/Typography';

import bg_speaker from '@assets/images/bg_speakers.png';
import styled from 'styled-components';

export const SpeakerItemWrapper = styled(Column)`
  border: 4px solid ${({ theme }) => theme.color.lightGrey};
  border-radius: ${({ theme }) => theme.borderRadius.radius10};
`;

export const FurtherInformation = styled(Row)`
  flex-wrap: wrap;
  &:hover {
    cursor: pointer;
  }
`;

export const TracksWrapper = styled.div`
  border-radius: ${({ theme }) => theme.borderRadius.radius20};
  background: url(${bg_speaker});
`;

export const SpeakerModalContentRoot = styled(Column)`
  padding: 0 4.5rem 4.5rem 4.5rem;
  margin-right: 1.25rem;
  margin-top: 3rem;
  height: 100%;
  overflow: auto;
  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width768}) {
    padding: 0 2.5rem 4.5rem 2.5rem;
  }
  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width480}) {
    padding: 0 1.5rem 4.5rem 1.5rem;
  }
`;

export const PosterContainer = styled(Column)`
  width: 100%;
  height: 100%;
  padding: 4rem;
  z-index: 2;
  gap: 2rem;
  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width768}) {
    padding: 3rem;
  }
  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width480}) {
    padding: 2rem;
  }
`;

export const TracksContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width768}) {
    display: flex;
    flex-direction: column;
    gap: 4rem;
  }
`;

export const TracksItems = styled(RowAlignedItems)`
  flex-wrap: wrap;
  gap: 1rem;
`;

export const SpeakerDetailsSection = styled(Column)`
  gap: 2rem;
`;

export const TopSpeakerDetailsSection = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  grid-gap: 4.5rem;
  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width1080}) {
    grid-gap: 3rem;
  }
  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width768}) {
    display: flex;
    flex-direction: column-reverse;
  }
`;

export const RightSideSpeakerBox = styled(Column)`
  background-color: ${({ theme }) => theme.color.mobilityGrey};
  border-radius: ${({ theme }) => theme.borderRadius.radius10};
  padding: 3.8rem;
  gap: 3rem;
  height: fit-content;
  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width768}) {
    order: -1;
    padding: 2rem;
  }
`;

export const SpeakerName = styled(P)`
  font-weight: ${({ theme }) => theme.fontWeight.weight700};
  line-height: ${({ theme }) => theme.lineHeight.height150};
  color: ${({ theme }) => theme.color.white};
`;

export const SpeakerJobCompany = styled(P)`
  line-height: ${({ theme }) => theme.lineHeight.height150};
  color: ${({ theme }) => theme.color.white};
`;

export const SpeakerInformation = styled(P)`
  line-height: ${({ theme }) => theme.lineHeight.height150};
  color: ${({ theme }) => theme.color.mobilityGrey};
  margin-top: 2rem;
`;

export const SessionTitle = styled(PBold)`
  color: ${({ theme }) => theme.color.mobilityGrey};
`;

export const CompanyLogoContainer = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  grid-gap: 5rem;

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width768}) {
    display: flex;
    flex-direction: column-reverse;
  }
`;

export const CompanyName = styled(PBold)`
  font-size: ${({ theme }) => theme.fontSize.size20};
  color: ${({ theme }) => theme.color.mobilityGrey};
`;

export const CompanyLogo = styled.img`
  height: auto;
  width: 19rem;
  object-fit: contain;

  border: 4px solid ${({ theme }) => theme.color.lightGrey};
  border-top: none;
  border-bottom-left-radius: ${({ theme }) => theme.borderRadius.radius10};
  border-bottom-right-radius: ${({ theme }) => theme.borderRadius.radius10};

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width768}) {
    width: 14rem;
  }
`;

export const BigCompanyLogo = styled.img`
  height: auto;
  width: 29rem;
  object-fit: cover;
  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width768}) {
    margin: auto;
  }
`;

export const TopSideSpeaker = styled.div<{ gridTemplateColumns?: string }>`
  display: grid;
  grid-template-columns: ${({ gridTemplateColumns }) =>
    gridTemplateColumns || 'auto 1fr'};
  gap: 3rem;
  width: 100%;
  max-width: 100%;
  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width480}) {
    gap: 1rem;
  }
`;

export const ProfilePhoto = styled.img`
  height: 19rem;
  width: 19rem;
  object-fit: cover;

  border: 4px solid ${({ theme }) => theme.color.lightGrey};
  border-bottom: none;
  border-top-left-radius: ${({ theme }) => theme.borderRadius.radius10};
  border-top-right-radius: ${({ theme }) => theme.borderRadius.radius10};

  cursor: pointer;

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width768}) {
    height: 14rem;
    width: 14rem;
  }
`;

export const Name = styled(P)`
  font-size: ${({ theme }) => theme.fontSize.size20};
  font-weight: ${({ theme }) => theme.fontWeight.weight900};
  line-height: ${({ theme }) => theme.lineHeight.height150};
  color: ${({ theme }) => theme.color.mobilityGrey};

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width768}) {
    font-size: ${({ theme }) => theme.fontSize.size18};
    font-weight: ${({ theme }) => theme.fontWeight.weight900};
    line-height: ${({ theme }) => theme.lineHeight.height140};
  }
`;

export const SpeakerDetails = styled(P)<{
  fontSize?: string;
  fontWeight?: string;
}>`
  color: ${({ theme }) => theme.color.mobilityGrey};

  font-size: ${({ fontSize, theme }) => fontSize || theme.fontSize.size18};
  font-weight: ${({ fontWeight, theme }) =>
    fontWeight || theme.fontWeight.weight400};
  line-height: ${({ theme }) => theme.lineHeight.height150};
  word-break: break-word;

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width768}) {
    font-size: ${({ theme }) => theme.fontSize.size16};
    line-height: ${({ theme }) => theme.lineHeight.height140};
  }
`;

export const FurtherInformationText = styled(P)<{ $color: string }>`
  color: ${({ $color }) => $color};
  font-size: ${({ theme }) => theme.fontSize.size18};
  line-height: ${({ theme }) => theme.lineHeight.height150};

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width768}) {
    font-size: ${({ theme }) => theme.fontSize.size16};
    line-height: ${({ theme }) => theme.lineHeight.height140};
  }

  &:hover {
    color: ${({ theme }) => theme.color.mobilityGrey};
  }
`;

export const SocialMediaContainer = styled(RowAlignedItems)`
  flex-wrap: wrap;
  gap: 0.8rem;
`;
